module.exports = __webpack_public_path__ + "img/zppointer.1e908b9f.png";